$(function () {

	$(window).on('load', function () {
		homeHeader($(this).scrollTop());
	});

	document.addEventListener('scroll', function () {
		homeHeader(document.body.scrollTop);
	}, true);

	function homeHeader(scrollPos) {
		const hd = $('#mini-header')
		scrollPos > $('#header').innerHeight() ? hd.removeClass('scroll-hidden') : hd.addClass('scroll-hidden');
	}

});
